import React, { useEffect, useState } from "react";
import TableLoader from "../../../Skeleton/TableLoader";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import Pagination from "../../../utils/Paginate";
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ListContentIndexTypes = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentIndexTypes: [],
    filteredContentIndexTypes: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-index-types `,
        apiHeader(token)
      )
      .then((res) => {
        const contentIndexTypes = res.data;
        console.log(contentIndexTypes);
        setState({
          ...state,
          contentIndexTypes: contentIndexTypes,
          filteredContentIndexTypes: contentIndexTypes,
        });
        setLoading(false);
        console.log(res.data[0]);
      })
      .catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-index-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({
          ...state,
          contentIndexTypes: [],
          filteredContentIndexTypes: [],
        });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({
      ...state,
      contentIndexTypes: [],
      filteredContentIndexTypes: [],
    });
    handleOnLoad();
    // this.props.history.push("/list-content-indexs");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-index-types?filter[limit]=50`;
    URL += `&filter[where][or][0][contentIndexTypeName][regexp]=/(${search})/i&filter[where][or][1][contentIndexTypeTitle][regexp]=/(${search})/i&filter[where][or][2][contentIndexTypeDescr][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentIndexTypes = res.data;
      console.log(contentIndexTypes);
      setState({ ...state, filteredContentIndexTypes: contentIndexTypes });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };
  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentIndexTypes.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>
    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Index Types</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        <Link to="/breeze/create-content-index-type">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        <Link to="/breeze/list-content-indices">
          <Button
            variant="contained"
            color="warning"
          >
            Indices
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group">
          <input
            className="form-control"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            id="exampleFormControlInput1"
            placeholder="Search"
          />
        </div>
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Title</th>
                <th scope="col">Description</th>
                <th scope="col">Code</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentIndexTypeId,
                    contentIndexTypeTitle,
                    contentIndexTypeName,
                    contentIndexTypeDescr,
                    contentIndexTypeValueCode,
                  }) => {
                    return (
                      <tr>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-index-types",
                              search: `?id=${contentIndexTypeId}`,
                            }}
                          >{contentIndexTypeId}</Link></td>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-index-types",
                              search: `?id=${contentIndexTypeId}`,
                            }}
                          >{contentIndexTypeTitle}</Link> </td>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-index-types",
                              search: `?id=${contentIndexTypeId}`,
                            }}
                          >{contentIndexTypeName}</Link> </td>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-index-types",
                              search: `?id=${contentIndexTypeId}`,
                            }}
                          > {contentIndexTypeDescr}</Link></td>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-index-types",
                              search: `?id=${contentIndexTypeId}`,
                            }}
                          > {contentIndexTypeValueCode}</Link></td>
                        <td>
                          <Link
                            className="btn btn-success"
                            to={{
                              pathname: "/manage-content-index-types",
                              search: `?id=${contentIndexTypeId}`,
                            }}
                          >
                            Edit{" "}
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentIndexTypeId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(5).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContentIndexTypes.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />
      </div>
    </form>
  );
};

export default ListContentIndexTypes;
